import { gql, useMutation } from '@apollo/client';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { TOAST_ACTIONS } from '../constants';
import { FetchPlacementsQuery } from './useQueryPlacements';

export const CreatePlacementMutation = gql`
  mutation CreatePlacement($placement: EditablePlacementFieldsInput!) {
    createPlacement(placement: $placement) {
      payload {
        id
        fields {
          placementName
          description
          mediaLayout
          campaignLimit
          hasTitle
          hasBody
          hasMedia
          hasDataFeeds
          hasOpenAction
          actionButtons {
            id
            title
          }
          payload
          destinations
          textFields
        }
      }
      message
    }
  }
`;

export const useCreatePlacement = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [createPlacement] = useMutation(CreatePlacementMutation, {
    onCompleted: () => {
      dispatch(addPositiveToast('Placement created successfully'));
      history.push('/settings/placements');
    },
    onError: (e) => {
      dispatch(
        addNegativeToastWithErrorId('Failed to create placement', TOAST_ACTIONS.createPlacement, e),
      );
    },
    refetchQueries: [
      // We need to fetch placements for both archived and nonarchived since the placements manage list uses archived placements
      // and other areas use only nonarchived placements like campaign creation
      {
        query: FetchPlacementsQuery,
        variables: {
          nonArchivedOnly: false,
        },
      },
      {
        query: FetchPlacementsQuery,
        variables: {
          nonArchivedOnly: true,
        },
      },
      'FetchPlacements',
    ],
  });

  return createPlacement;
};
